// Helpers para determinar si una variante o producto está disponible.
//
// En Medusa 2, una variante NO está en stock sólo cuando:
//   - manage_inventory === true, Y
//   - allow_backorder !== true, Y
//   - inventory_quantity (o la suma de ubicaciones) <= 0.
// Si manage_inventory es false, Medusa no gestiona stock para esa variante y
// se considera siempre disponible. Si allow_backorder es true, también.

function getVariantInventoryQuantity(variant) {
  if (!variant) return 0;
  if (typeof variant.inventory_quantity === 'number') {
    return variant.inventory_quantity;
  }
  // Fallback: sumar stocked_quantity de los inventory_items (si vinieran expandidos)
  const items = variant.inventory_items || [];
  let total = 0;
  for (const it of items) {
    const levels = it?.inventory?.location_levels || [];
    for (const lvl of levels) {
      const stocked = Number(lvl?.stocked_quantity) || 0;
      const reserved = Number(lvl?.reserved_quantity) || 0;
      total += Math.max(stocked - reserved, 0);
    }
  }
  return total;
}

export function isVariantInStock(variant) {
  if (!variant) return false;
  if (!variant.manage_inventory) return true;
  if (variant.allow_backorder) return true;
  return getVariantInventoryQuantity(variant) > 0;
}

export function isProductInStock(medusaProduct) {
  const variants = medusaProduct?.variants || [];
  if (variants.length === 0) return true;
  return variants.some(isVariantInStock);
}
